import React, { useState } from 'react';
import { List, IndentIcon, AlignLeft, ListOrdered } from 'lucide-react';

const FormatTools = ({ 
  onBulletPoint, 
  onNumberedList, 
  onIndentation, 
  onParagraph, 
  bulletPointActive, 
  numberedListActive,
  conceptIndex,
  onFormatSelection,
  onFormatStateChange,
  className = 'absolute top-3 right-3 flex space-x-1',
}) => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleFormatClick = (type, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === 'bullet' || type === 'number') {
      onFormatStateChange?.(type);
    }

    if (onFormatSelection) {
      onFormatSelection(type, e);
    } else {
      switch (type) {
        case 'bullet':
          onBulletPoint();
          break;
        case 'number':
          onNumberedList();
          break;
        case 'indent':
          onIndentation();
          break;
        case 'paragraph':
          onParagraph();
          break;
        default:
          break;
      }
    }
  };

  const FormatButton = ({ type, icon: Icon, tooltip, isActive }) => (
    <div className="relative format-button">
      <button
        onClick={(e) => handleFormatClick(type, e)}
        onMouseEnter={() => setActiveTooltip(`${tooltip}-${conceptIndex}`)}
        onMouseLeave={() => setActiveTooltip(null)}
        className={`p-2 rounded transition-colors ${
          isActive 
            ? 'bg-cranberry-600 text-white hover:bg-cranberry-700' 
            : 'bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600'
        }`}
      >
        <Icon size={16} />
      </button>
      {activeTooltip === `${tooltip}-${conceptIndex}` && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded-md shadow-sm dark:bg-gray-700 whitespace-nowrap z-50">
          {tooltip}
        </div>
      )}
    </div>
  );

  return (
    <div className={className}>
      <FormatButton 
        type="bullet"
        icon={List} 
        tooltip="Add bullet point" 
        isActive={bulletPointActive}
      />
      <FormatButton 
        type="number"
        icon={ListOrdered} 
        tooltip="Add numbered list" 
        isActive={numberedListActive}
      />
      <FormatButton 
        type="indent"
        icon={IndentIcon} 
        tooltip="Add indentation"
      />
      <FormatButton 
        type="paragraph"
        icon={AlignLeft} 
        tooltip="Add paragraph"
      />
    </div>
  );
};

export default FormatTools; 